import React from "react";
import { ModifierGroup } from "./ModifierGroup";
import { OptionsSelector } from "./OptionsSelector";
export var AvailableModifierGroups = function (_a) {
    var groups = _a.groups, modifiers = _a.modifiers, choices = _a.choices, includedSelectedWeight = _a.includedSelectedWeight, maxToppings = _a.maxToppings, onSetFirstHalf = _a.onSetFirstHalf, onSetSecondHalf = _a.onSetSecondHalf, onSetWhole = _a.onSetWhole, onSetExtra = _a.onSetExtra, onSetNormal = _a.onSetNormal, onRemove = _a.onRemove;
    var calculateSelectionWeight = function (choice) {
        if (!choice || choice.quantity <= 0) {
            return 0;
        }
        var portionWeight = choice.portion === "first-half" || choice.portion === "second-half" ? 0.5 : 1;
        var sizeWeight = choice.size === "extra" ? 2 : 1;
        return choice.quantity * portionWeight * sizeWeight;
    };
    var optionalModifierIds = groups.reduce(function (allModifiers, group) {
        (group.modifiers || []).forEach(function (modifierId) {
            var modifierKey = String(modifierId);
            if (!allModifiers.includes(modifierKey)) {
                allModifiers.push(modifierKey);
            }
        });
        return allModifiers;
    }, []);
    var optionalSelectedWeight = optionalModifierIds.reduce(function (runningTotal, modifierId) {
        return runningTotal + calculateSelectionWeight(choices[modifierId]);
    }, 0);
    var totalSelectedWeight = includedSelectedWeight + optionalSelectedWeight;
    return (React.createElement(React.Fragment, null, groups.filter(function (group) { return (group.modifiers || []).length > 0; }).map(function (group) {
        var selectedWeight = group.modifiers.reduce(function (runningTotal, modifierId) {
            var key = String(modifierId);
            return runningTotal + calculateSelectionWeight(choices[key]);
        }, 0);
        var groupLimit = group.maxAllowed || 0;
        var hasGlobalLimit = maxToppings > 0;
        var effectiveDisplayLimit = groupLimit > 0 && hasGlobalLimit ? Math.min(groupLimit, maxToppings) : groupLimit || maxToppings || 0;
        var displaySelectedWeight = groupLimit > 0 && (maxToppings <= 0 || groupLimit <= maxToppings) ? selectedWeight : totalSelectedWeight;
        return (React.createElement(ModifierGroup, { key: group.name, title: group.name, maxAllowed: effectiveDisplayLimit, selectedCount: displaySelectedWeight },
            React.createElement(OptionsSelector, { modifierIds: group.modifiers, modifiers: modifiers, choices: choices, maxAllowed: groupLimit, selectedWeight: selectedWeight, totalSelectedWeight: totalSelectedWeight, maxToppings: maxToppings, onSetFirstHalf: onSetFirstHalf, onSetSecondHalf: onSetSecondHalf, onSetWhole: onSetWhole, onSetExtra: onSetExtra, onSetNormal: onSetNormal, onRemove: onRemove })));
    })));
};
